import { t } from '../../../locales';
import { useAuthStore } from '@/v2/store/shared/auth-store';
import { canManageHomepageSections } from './entities/homepage-sections';

const agentEcommerceRoutes = {
	path: 'agent-ecommerce',
	component: () => import('./module-layout.vue'),
	children: [
		// Brands routes
		{
			path: 'brands',
			component: () => import('./pages/brands/index.vue'),
			meta: {
				title: t('e-agent.titles.brands'),
			},
		},
		{
			path: 'brands/new',
			component: () => import('./pages/brands/form.vue'),
			meta: {
				title: t('e-agent.titles.addBrand'),
			},
		},
		{
			path: 'brands/:id/edit',
			component: () => import('./pages/brands/form.vue'),
			meta: {
				title: t('e-agent.titles.editBrand'),
			},
		},

		// Categories routes
		{
			path: 'categories',
			component: () => import('./pages/categories/index.vue'),
			meta: {
				title: t('sidebar.categories'),
			},
		},
		{
			path: 'categories/new',
			component: () => import('./pages/categories/form.vue'),
			meta: {
				title: t('e-agent.titles.addCategory'),
			},
		},
		{
			path: 'categories/:id/edit',
			component: () => import('./pages/categories/form.vue'),
			meta: {
				title: t('e-agent.titles.editCategory'),
			},
		},

		// Products routes
		{
			path: 'products',
			component: () => import('./pages/products/index.vue'),
			meta: {
				title: t('e-agent.titles.products'),
			},
		},
		{
			path: 'products/new',
			component: () => import('./pages/products/form.vue'),
			meta: {
				title: t('e-agent.titles.addProduct'),
			},
		},
		{
			path: 'products/:id/edit',
			component: () => import('./pages/products/form.vue'),
			meta: {
				title: t('e-agent.titles.editProduct'),
			},
		},

		// Orders routes
		{
			path: 'orders',
			component: () => import('./pages/orders/index.vue'),
			meta: {
				title: t('e-agent.titles.orders'),
			},
		},
		{
			path: 'orders/:id',
			component: () => import('./pages/orders/details.vue'),
			meta: {
				title: t('e-agent.titles.orderDetails'),
			},
		},
		{
			path: 'orders/print/:id',
			name: 'agent-order-print',
			props: true,
			component: () => import('./pages/orders/print.vue'),
			meta: {
				title: t('e-agent.titles.orderDetails'),
			},
		},
		{
			path: 'invoice/print/:id',
			name: 'agent-invoice-print',
			props: true,
			component: () => import('./pages/orders/invoice-print.vue'),
			meta: {
				title: t('e-agent.invoice.invoice-details'),
			},
		},
		{
			path: 'orders/new/:id',
			component: () => import('./pages/orders/create.vue'),
			meta: {
				title: t('e-agent.titles.createOrder'),
			},
			props: true,
		},
		{
			path: 'orders/edit/:id',
			component: () => import('./pages/orders/create.vue'),
			meta: {
				title: t('e-agent.titles.editOrder'),
			},
			props: true,
		},

		// Stores routes
		{
			path: 'stores',
			component: () => import('./pages/stores/index.vue'),
			meta: {
				title: t('e-agent.titles.stores'),
			},
		},
		{
			path: 'stores/new',
			component: () => import('./pages/stores/form.vue'),
			meta: {
				title: t('e-agent.titles.addStore'),
			},
		},
		{
			path: 'stores/:id/edit',
			component: () => import('./pages/stores/form.vue'),
			meta: {
				title: t('e-agent.titles.editStore'),
			},
		},

		// Discounts routes
		{
			path: 'discounts',
			component: () => import('./pages/discounts/index.vue'),
			meta: {
				title: t('e-agent.titles.discounts'),
			},
		},
		{
			path: 'discounts/new/products',
			component: () =>
				import('./pages/discounts/components/discount-types/product-discount-form.vue'),
			meta: {
				title: t('e-agent.titles.createProductDiscount'),
			},
		},
		{
			path: 'discounts/new/order',
			component: () =>
				import('./pages/discounts/components/discount-types/order-discount-form.vue'),
			meta: {
				title: t('e-agent.titles.createOrderDiscount'),
			},
		},
		{
			path: 'discounts/new/shipping',
			component: () =>
				import('./pages/discounts/components/discount-types/shipping-discount-form.vue'),
			meta: {
				title: t('e-agent.titles.createShippingDiscount'),
			},
		},
		{
			path: 'discounts/new/buy-x-get-y',
			component: () =>
				import('./pages/discounts/components/discount-types/buy-x-get-y-discount-form.vue'),
			meta: {
				title: t('e-agent.titles.createBuyXGetYDiscount'),
			},
		},
		{
			path: 'discounts/:id/edit',
			component: () => import('./pages/discounts/edit/page.vue'),
			meta: {
				title: t('e-agent.titles.editDiscount'),
			},
		},

		// Options routes
		{
			path: 'options',
			component: () => import('./pages/options/index.vue'),
			meta: {
				title: t('e-agent.titles.options'),
			},
		},
		{
			path: 'options/new',
			component: () => import('./pages/options/form.vue'),
			meta: {
				title: t('e-agent.titles.addOption'),
			},
		},
		{
			path: 'options/:id/edit',
			component: () => import('./pages/options/form.vue'),
			meta: {
				title: t('e-agent.titles.editOption'),
			},
		},

		// Tags routes
		{
			path: 'tags',
			component: () => import('./pages/tags/index.vue'),
			meta: {
				title: t('e-agent.titles.tags'),
			},
		},
		{
			path: 'tags/new',
			component: () => import('./pages/tags/form.vue'),
			meta: {
				title: t('e-agent.titles.addTag'),
			},
		},
		{
			path: 'tags/:id/edit',
			component: () => import('./pages/tags/form.vue'),
			meta: {
				title: t('e-agent.titles.editTag'),
			},
		},

		// Mosques routes
		{
			path: 'mosques',
			component: () => import('./pages/mosques/index.vue'),
			meta: {
				title: t('e-agent.titles.mosques'),
			},
		},
		{
			path: 'mosques/new',
			component: () => import('./pages/mosques/form.vue'),
			meta: {
				title: t('e-agent.titles.addMosque'),
			},
		},
		{
			path: 'mosques/:id/edit',
			component: () => import('./pages/mosques/form.vue'),
			meta: {
				title: t('e-agent.titles.editMosque'),
			},
		},

		// Transactions routes
		{
			path: 'transactions',
			component: () => import('./pages/transactions/index.vue'),
			meta: {
				title: t('reports.transactions'),
			},
		},
		{
			path: 'transactions/:paymentGateway/:id',
			component: () => import('./pages/transactions/details.vue'),
			meta: {
				title: t('e-agent.transaction-details'),
			},
			props: true,
		},

	// Payment Methods Configuration routes
	{
		path: 'payment-methods-configuration',
		component: () => import('./pages/payment-methods-configuration/index.vue'),
		meta: {
			title: t('e-agent.payment-methods-configuration.title'),
		},
	},

	// Billing Settings routes (Tax & Invoice)
	{
		path: 'billing-settings',
		component: () => import('./pages/billing-settings/index.vue'),
		meta: {
			title: t('e-agent.billing-settings.title'),
		},
	},

		// Upload Products routes
		{
			path: 'upload-products',
			component: () => import('./pages/upload-products/index.vue'),
			meta: {
				title: t('e-agent.upload-products.title'),
			},
		},

		// Agent Settings routes
		{
			path: 'agent-settings',
			component: () => import('./pages/agent-settings/index.vue'),
			meta: {
				title: t('e-agent.agent-settings.title'),
			},
		},

		// General Settings routes
		{
			path: 'general-settings',
			component: () => import('./pages/general-settings/index.vue'),
			meta: {
				title: t('e-agent.general-settings.title'),
			},
		},

		// Storefront homepage sections (tenant-gated)
		{
			path: 'homepage-sections',
			component: () => import('./pages/homepage-sections/index.vue'),
			meta: {
				title: t('e-agent.homepage-sections.title'),
				can: () => canManageHomepageSections(useAuthStore().tenantId),
			},
		},

		// Shipping Configuration
		{
			path: 'shipping-configuration',
			component: () => import('./pages/shipping-configuration/index.vue'),
			meta: {
				title: t('e-agent.shipping-configuration.title'),
			},
		},
		{
			path: 'shipping-configuration/shipping-options/new',
			component: () => import('./pages/shipping-configuration/components/shipping-options/form.vue'),
			meta: {
				title: t('e-agent.shipping-options.create'),
			},
		},
		{
			path: 'shipping-configuration/shipping-options/:id/edit',
			component: () => import('./pages/shipping-configuration/components/shipping-options/form.vue'),
			meta: {
				title: t('e-agent.shipping-options.edit'),
			},
		},

		// Customer Profiles routes
		{
			path: 'customer-profiles',
			component: () => import('./pages/customer-profiles/index.vue'),
			meta: {
				title: t('e-agent.titles.customer-profiles'),
			},
		},

		// Reports routes
		{
			path: 'reports/products-sales',
			component: () => import('./pages/reports/products-sales/index.vue'),
			meta: {
				title: t('e-agent.products-sales-report'),
			},
		},
		{
			path: 'reports/invoices-report',
			component: () => import('./pages/reports/invoices-report/index.vue'),
			meta: {
				title: t('e-agent.invoices-report.title'),
			},
		},

		{
			path: 'reports/orders',
			component: () => import('./pages/reports/orders/index.vue'),
			meta: {
				title: t('e-agent.orders-report.title'),
			},
		},
		{
			path: 'reports/sales-report',
			component: () => import('./pages/reports/sales-report/index.vue'),
			meta: {
				title: t('e-agent.sales-report.title'),
			},
		},
		{
			path: 'reports/profit-report',
			component: () => import('./pages/reports/profit-report/index.vue'),
			meta: {
				title: t('e-agent.profit-report.title'),
			},
		},
		{
			path: 'reports/stock-report',
			component: () => import('./pages/reports/stock-report/index.vue'),
			meta: {
				title: t('e-agent.stock-report.title'),
			},
		},
		{
			path: 'reports/best-customer',
			component: () => import('./pages/reports/best-customer/index.vue'),
			meta: {
				title: t('e-agent.best-customer-report.title'),
			},
		},
		{
			path: 'reports/best-selling-products',
			component: () => import('./pages/reports/best-selling-products/index.vue'),
			meta: {
				title: t('e-agent.best-selling-products-report.title'),
			},
		},
		{
			path: 'reports/returned-orders',
			component: () => import('./pages/reports/returned-orders/index.vue'),
			meta: {
				title: t('e-agent.returned-orders-report.title'),
			},
		},
		{
			path: 'reports/inventory-valuation-report',
			component: () => import('./pages/reports/inventory-valuation-report/index.vue'),
			meta: {
				title: t('e-agent.inventory-valuation-report.title'),
			},
		},
		{
			path: 'reports/discount-usage-report',
			component: () => import('./pages/reports/discount-usage-report/index.vue'),
			meta: {
				title: t('e-agent.discount-usage-report.title'),
			},
		},
		{
			path: 'reports/customer-retention',
			component: () => import('./pages/reports/customer-retention/index.vue'),
			meta: {
				title: t('e-agent.customer-retention-report.title'),
			},
		},
		{
			path: 'imports/:id',
			component: () => import('./pages/imports/details.vue'),
			meta: {
				title: t('e-agent.imports.details.title'),
			},
		},
	],
};

export { agentEcommerceRoutes };
